import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ServiceLocation } from 'src/api/@generated/backend-api';

import { AddressState } from './types';

const initialState: AddressState = {};

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setServiceLocation: (state, action: PayloadAction<ServiceLocation>) => {
      state.selectedServiceLocation = action.payload;
    },
    resetServiceLocation: (state) => {
      state.selectedServiceLocation = undefined;
    },
  },
});

export const {
  actions: { setServiceLocation, resetServiceLocation },
  reducer: addressSliceReducer,
} = addressSlice;
